import styles from "@styles/components/General/BareScreen.module.css"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';

const BareScreen = ({ children, title, subtitle, backgroundColour, showBackButton = false, onBackClick, scrollable = false, justifyContent = 'flex-start' }: { 
    children: React.ReactNode, 
    title: string, 
    subtitle: string, 
    backgroundColour?: string,
    scrollable?: boolean,
    showBackButton?: boolean,
    onBackClick?: () => void,
    justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly'
}) => {
    return (
    <div className={styles['content-block']} style={{ backgroundColor: backgroundColour, overflowY: scrollable ? 'auto' : 'hidden' }}>
        <div className={styles['header-container']}>
            {showBackButton && (
                <IconButton onClick={onBackClick} className={styles['back-button']}>
                    <ArrowBackIcon  style={{width: "auto", height: "auto"}}/>
                </IconButton>
            )}
            <div className={styles['title-container']}>
                <h2 className={styles['title']}>
                    {title}
                    {subtitle && <p className={styles['sub-title']}>{subtitle}</p>}
                </h2>
            </div>
        </div>
        <div className={styles['container']} style={{ justifyContent }}>
            {children}
        </div>
    </div>
    );
}

export default BareScreen;